import { EPaymentMethod } from '@if/core/types'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import LocalAtmIcon from '@mui/icons-material/LocalAtm'
import PaymentsIcon from '@mui/icons-material/Payments'
import RequestPageIcon from '@mui/icons-material/RequestPage'
import { Tooltip } from '@mui/material'
import { DEFAULT_PAYMENT_METHOD } from '@src/types/constants'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  paymentMode: EPaymentMethod | undefined
}

export const PaymentMethodIconComponent = ({ paymentMode }: Props): ReactNode => {
  const { t } = useTranslation()

  const effectivePaymentMode = paymentMode ?? DEFAULT_PAYMENT_METHOD
  const paymentMethodLabel = t(`loan.payment.pmtMode.${effectivePaymentMode}`)

  let content: ReactNode

  switch (effectivePaymentMode) {
    case EPaymentMethod.PreAuthorizedPayment:
      content = <PaymentsIcon aria-hidden="true" />
      break
    case EPaymentMethod.Check:
      content = <CreditCardIcon aria-hidden="true" />
      break
    case EPaymentMethod.Cash:
      content = <LocalAtmIcon aria-hidden="true" />
      break
    case EPaymentMethod.InteracETransfer:
      content = <RequestPageIcon aria-hidden="true" />
      break
    default:
      content = <PaymentsIcon aria-hidden="true" />
  }

  return (
    <Tooltip title={paymentMethodLabel}>
        {content}
    </Tooltip>
  )
}
